import { ConditionParams } from "@multiweb/clients/dataReader";
import { MEChangeGroup } from "./MEChangeGroup";
import { IMEConditionGroup, MEChanges, MEInstance } from "./types";

/**
 * Skupina změn zadaná podmínkou
 * @internal
 */
export class MEConditionGroup extends MEChangeGroup implements IMEConditionGroup {
    /** Podmínka pro výběr objektů */
    public readonly condition: string;
    /** Parametry podmínky pro výběr objektů */
    public readonly conditionParams: ConditionParams;

    constructor(condition: string, conditionParams: ConditionParams) {
        super();
        this.condition = condition;
        this.conditionParams = conditionParams;
    }

    /**
     * Vrací seznam změn vzhledem k předchozímu stavu
     * @param _existingInstances Seznam instancí, pro které se změny aplikovaly instančně
     * @param intersectsInstances Seznam objektů, které aplikují změny instančně a spadají do této skupiny
     */
    public merge(_existingInstances: readonly string[], intersectsInstances: readonly string[]): MEChanges {
        const changedInstances: MEInstance[] = [];
        intersectsInstances.forEach(i => {
            changedInstances.push({ id: i, values: this._changes });
            this.exclude(i);
        });
        return { changedInstances, newGroups: [this] };
    }
}
